<template>
  <div class="wrapper flex-column align-center justify-center full-parent">
    <div class="bg-block">
      <div class="info-block">
        <div class="title nowrap">关于我们</div>
        <div class="desc nowrap">ABOUT US</div>
        <div class="content">
          我们是一群来自腾讯的爸妈，我们和你一样，经历了初为父母的欣喜和激动。然而，无奈在月子期间经历了种种磨难，却也只能请到一位经过虚假包装、存在种种陋习的高价月嫂。
        </div>
        <div class="content">
          我们不想你跟我们一样，我们不想再有宝宝经历传统陋习！为人父母的爱与责任，驱使让我们出发了。
        </div>
        <div class="content">
          让每一位宝宝都得到科学照顾、让每一位妈妈不做后悔妈妈，是我们成立妈妈来了的初心。妈妈来了，让爱可以信赖！这是我们对你的承诺。
        </div>
      </div>

      <img
        draggable="false"
        class="bg"
        src="https://mm2015.mamalaile.com.cn/1a56acfa5b3746b3782c1cc8b340e7d5.png"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({});
</script>

<style lang="less" scoped>
.wrapper {
  .bg-block {
    position: relative;

    .info-block {
      position: absolute;
      left: 3.12vw;
      top: 3.12vw;
      color: white;

      .title {
        font-size: 1.82vw;
        line-height: 2.5vw;
        font-family: @font-ab;
        margin-bottom: 0.26vw;
      }

      .desc {
        font-size: 1.04vw;
        line-height: 1.41vw;
        font-family: @font-am;
        margin-bottom: 2.08vw;
      }

      .content {
        width: 25vw;
        font-size: 0.73vw;
        line-height: 1.56vw;
        text-align: justify;
        margin-bottom: 1.4vw;
      }
    }

    .bg {
      width: 86vw;
    }
  }
}
</style>